import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    creating: -1,
    loading: -1,
    updating: -1,
  },
  data: {},
  pharmacies: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    // get getPharmacies
    case ACTION_TYPES.PHARMACY_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.PHARMACY_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        pharmacies: payload.data,
      };
    case ACTION_TYPES.PHARMACY_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        pharmacies: [],
        error: {
          message: 'Cannot get pharmacies successfully!',
        },
      };

    default:
      return state;
  }
}
